export const UI = {
  mobileHeaderHeight: 50,
  headerHeight: 64,
  appBarHeight: 73,
  drawerWidthMobile: 313,
  drawerWidthDesktop: 372,
  filterDrawerWidthDesktop: 450,
  searchWidth: 312,
  contentMaxWidth: 648,
  pageMaxWidth: 1440,
  contentSpacingMobile: 16,
  closeButtonSize: 40,
  contentSpacingDesktop: 24,
  arrowNextSize: 24,
  popperWidth: 314,
  popperHeight: 294,
  popperBodyWidth: 305,
  chatHeaderHeight: 66,
  courseCardWidth: 312,
  avatarSize: {
    big: 44,
    medium: 28,
    small: 24
  }
};

export const hashTagRegexSafari = `(?:(^|\\s))#[^\\s#]+(?=($|\\s))`;

export const mentionRegex = /\[@(\w*)\|([\w|-]*)\]/g;

export const pinInputRegexCriteria = /^[ A-Za-z0-9_@./#&+-]*$/;

export const displayNameRegex =
  /^([A-Za-z\u0020\u002D\u002E\u0041-\u005A\u0061-\u007A\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u01BF\u01C4-\u024F\u1E02-\u1EF3,(,),|,/\s]*)$/g;

export const TENANT_INFO_URL = "https://talkout.com/tenantInfo";

export const PASSWORD_REGEX = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/;

export const CHAT_MESSAGE_DATE_FORMAT = "HH:mm d/MM/yyyy";

export const URL_REGEX = /https?:\/\/[\w./\-=!?&<>[\]]+/gi;

export const PATHS_URL = "https://www.talkout.com/paths";

export const DATE_FORMAT_REGEX = /^(?!00)[0-9]{2}[/][0-9]{2}[/][1-9]{1}[9]{1}[0-9]{2}$/;

export const DEFAULT_MAX_REEL_DURATION_SECONDS = 120;

export const APP_STORE_LINK = "https://apps.apple.com/gb/app/talkout-paths/id1573596224";
export const GOOGLE_PLAY_LINK = "https://play.google.com/store/apps/details?id=com.talkout.talkoutapp";
